export default __webpack_public_path__ + "static/media/LOGO CABANG DINAS-05.eba0398b.png";